import React from "react";

import { setLocalKlimVar, useTranslation } from "utils";

import { Button, Card, Link } from "components";

export const SignUpNudgeCard = ({ redirectLink }) => {
  const { t } = useTranslation("articles");

  const handleLinkClick = () => {
    setLocalKlimVar("urlSlice", redirectLink);
  };

  return (
    <Card className="signup-nudge-card">
      <div className="center">
        <h3 className="margin-bottom-100">{t("signUpNudgeCard.title")}</h3>
        <Button className="signup-nudge-cta-button" dataTestId="users-signup-nudge-cta" type="primary" onClick={handleLinkClick} href="/sign-up">
          {t("signUpNudgeCard.buttonText")}
        </Button>
        <p>
          {t("signUpNudgeCard.haveAccount")}{" "}
          <Link dataTestId="users-signup-nudge-login-link" to="/sign-in" onClick={handleLinkClick}>
            {t("signUpNudgeCard.logInLinkText")}
          </Link>
        </p>
      </div>
    </Card>
  );
};
